module.exports = __webpack_public_path__ + "e27da41af2b66979d8ad057bf7781d53.png";